

import React from 'react';




import O from './../../images/ope.png';
import O2 from './../../images/clo.png';
import C from './../../images/conc.png';
import C2 from './../../images/unc.png';
import E from './../../images/ext.png';
import E2 from './../../images/int.png';
import A from './../../images/agr.png';
import A2 from './../../images/dis.png';
import S from './../../images/sta.png';
import S2 from './../../images/neu.png';

import { combinationsText } from './../../text/combinations-text.js';

import PremiumLockbox from './premium-lockbox';


import { motion } from 'framer-motion';


const opeName = "Curious";
const cloName = "Practical";
const conName = "Structured";
const uncName = "Unstructured";
const extName = "Extraverted";
const intName = "Introverted";
const agrName = "Agreeable";
const disName = "Disagreeable";
const staName = "Emotionally stable";
const neuName = "Sensitive";



let opeLogo;
let conLogo;
let extLogo;
let agrLogo;
let staLogo;



const CombinationsTab = ({ opeLevel, conLevel, extLevel, agrLevel, staLevel, setPremiumModalOpen, isPaid }) => {


    let combinationList = [];

    // for testing
    //opeLevel = 7;
    //conLevel = 6;
    //extLevel = 4;
    //agrLevel = 5;
    //staLevel = 1;

    const Combination = ({ logo1, logo2, title1, title2, relevance, comboTitle, comboText }) => {

        return (

            <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 , transition: { delay: 0.3 }}}
            viewport={{ once: true }}
          >

                <div className="result-combination">
                    <div className="combinations-title" >
                        <div className="facet-combinations-logos">
                            <div className="normal-flex-divider">
                                <img className="facet-title-logo" src={logo1} alt="logo" />
                                <div className="facet-combinations-plus" >
                                    +
                                </div>

                                <img className="facet-title-logo" src={logo2} />
                            </div>
                        </div>
                        <h4 className="subheading">
                            {title1} + {title2}
                        </h4>
                        <h2 className="title">
                            {comboTitle}
                        </h2>
                    </div>
                    <div className="vertical-spacer" />
                    <div>
                        {comboText}
                    </div>

                    <div className="vertical-spacer" />

                    <div className="subheading flex-center">   Correlation strength:  < div className="correlation-pips">
                        < div className="correlation-pip" />

                        {(relevance >= 3) ?
                            < div className="correlation-pip" />
                            : <></>
                        }

                        {(relevance >= 5) ?
                            < div className="correlation-pip" />
                            : <></>
                        }
                    </div>
                    </div>
                    <div className="vertical-spacer" />


                    <hr />
                </div>

            </motion.div>

        )

    }



    // open to experience
    if (opeLevel > 4 && conLevel > 4) {

        const relevance = (opeLevel - 4) + (conLevel - 4);

        combinationList.push(<Combination logo1={O} logo2={C} title1={opeName} title2={conName} relevance={relevance}
            comboTitle={combinationsText.opeConTitle} comboText={combinationsText.opeConText} key={combinationsText.opeConTitle} />);

    }

    if (opeLevel > 4 && conLevel < 4) {

        const relevance = (opeLevel - 4) + (4 - conLevel);


        combinationList.push(<Combination logo1={O} logo2={C2} title1={opeName} title2={uncName} relevance={relevance}
            comboTitle={combinationsText.opeUncTitle} comboText={combinationsText.opeUncText} key={combinationsText.opeUncTitle} />);

    }

    if (opeLevel > 4 && extLevel > 4) {

        const relevance = (opeLevel - 4) + ( extLevel - 4);

        combinationList.push(<Combination logo1={O} logo2={E} title1={opeName} title2={extName} relevance={relevance}
            comboTitle={combinationsText.opeExtTitle} comboText={combinationsText.opeExtText} key={combinationsText.opeExtTitle} />);

    }

    if (opeLevel > 4 && extLevel < 4) {

        const relevance = (opeLevel - 4) + ( 4 - extLevel);

        combinationList.push(<Combination logo1={O} logo2={E2} title1={opeName} title2={intName} relevance={relevance}
            comboTitle={combinationsText.opeIntTitle} comboText={combinationsText.opeIntText} key={combinationsText.opeIntTitle} />);

    }

    if (opeLevel > 4 && agrLevel > 4) {

        const relevance = (opeLevel - 4) + ( agrLevel - 4);

        combinationList.push(<Combination logo1={O} logo2={A} title1={opeName} title2={agrName} relevance={relevance}
            comboTitle={combinationsText.opeAgrTitle} comboText={combinationsText.opeAgrText} key={combinationsText.opeAgrTitle} />);

    }

    if (opeLevel > 4 && agrLevel < 4) {

        const relevance = (opeLevel - 4) + ( 4 - agrLevel);

        combinationList.push(<Combination logo1={O} logo2={A2} title1={opeName} title2={disName} relevance={relevance}
            comboTitle={combinationsText.opeDisTitle} comboText={combinationsText.opeDisText} key={combinationsText.opeDisTitle} />);

    }

    if (opeLevel > 4 && staLevel > 4) {

        const relevance = (opeLevel - 4) + (staLevel - 4);

        combinationList.push(<Combination logo1={O} logo2={S} title1={opeName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.opeStaTitle} comboText={combinationsText.opeStaText} key={combinationsText.opeStaTitle} />);

    }

    if (opeLevel > 4 && staLevel < 4) {

        const relevance = (opeLevel - 4) + (4 - staLevel);

        combinationList.push(<Combination logo1={O} logo2={S2} title1={opeName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.opeNeuTitle} comboText={combinationsText.opeNeuText} key={combinationsText.opeNeuTitle} />);

    }


    //closed to experience

    if (opeLevel < 4 && conLevel > 4) {

        const relevance = (4 - opeLevel) + (conLevel - 4);

        combinationList.push(<Combination logo1={O2} logo2={C} title1={cloName} title2={conName} relevance={relevance}
            comboTitle={combinationsText.cloConTitle} comboText={combinationsText.cloConText} key={combinationsText.cloConTitle} />);

    }

    if (opeLevel < 4 && conLevel < 4) {

        const relevance = (4 - opeLevel) + (4 - conLevel);

        combinationList.push(<Combination logo1={O2} logo2={C2} title1={cloName} title2={uncName} relevance={relevance}
            comboTitle={combinationsText.cloUncTitle} comboText={combinationsText.cloUncText} key={combinationsText.cloUncTitle} />);

    }

    if (opeLevel < 4 && extLevel > 4) {

        const relevance = (4 - opeLevel) + (extLevel - 4);

        combinationList.push(<Combination logo1={O2} logo2={E} title1={cloName} title2={extName} relevance={relevance}
            comboTitle={combinationsText.cloExtTitle} comboText={combinationsText.cloExtText} key={combinationsText.cloExtTitle} />);

    }

    if (opeLevel < 4 && extLevel < 4) {

        const relevance = (4 - opeLevel) + (4 - extLevel);

        combinationList.push(<Combination logo1={O2} logo2={E2} title1={cloName} title2={intName} relevance={relevance}
            comboTitle={combinationsText.cloIntTitle} comboText={combinationsText.cloIntText} key={combinationsText.cloIntTitle} />);

    }

    if (opeLevel < 4 && agrLevel > 4) {

        const relevance = (4 - opeLevel) + (agrLevel - 4);

        combinationList.push(<Combination logo1={O2} logo2={A} title1={cloName} title2={agrName} relevance={relevance}
            comboTitle={combinationsText.cloAgrTitle} comboText={combinationsText.cloAgrText} key={combinationsText.cloAgrTitle} />);

    }

    if (opeLevel < 4 && agrLevel < 4) {

        const relevance = (4 - opeLevel) + (4 - agrLevel);

        combinationList.push(<Combination logo1={O2} logo2={A2} title1={cloName} title2={disName} relevance={relevance}
            comboTitle={combinationsText.cloDisTitle} comboText={combinationsText.cloDisText} key={combinationsText.cloDisTitle} />);

    }

    if (opeLevel < 4 && staLevel > 4) {

        const relevance = (4 - opeLevel) + (staLevel - 4);

        combinationList.push(<Combination logo1={O2} logo2={S} title1={cloName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.cloStaTitle} comboText={combinationsText.cloStaText} key={combinationsText.cloStaTitle} />);

    }

    if (opeLevel < 4 && staLevel < 4) {

        const relevance = (4 - opeLevel) + (4 - staLevel);

        combinationList.push(<Combination logo1={O2} logo2={S2} title1={cloName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.cloNeuTitle} comboText={combinationsText.cloNeuText} key={combinationsText.cloNeuTitle} />);

    }


    //concientious

    if (conLevel > 4 && extLevel > 4) {

        const relevance = (conLevel - 4) + (extLevel - 4);

        combinationList.push(<Combination logo1={C} logo2={E} title1={conName} title2={extName} relevance={relevance}
            comboTitle={combinationsText.conExtTitle} comboText={combinationsText.conExtText} key={combinationsText.conExtTitle} />);

    }

    if (conLevel > 4 && extLevel < 4) {

        const relevance = (conLevel - 4) + (4 - extLevel);

        combinationList.push(<Combination logo1={C} logo2={E2} title1={conName} title2={intName} relevance={relevance}
            comboTitle={combinationsText.conIntTitle} comboText={combinationsText.conIntText} key={combinationsText.conIntTitle} />);

    }

    if (conLevel > 4 && agrLevel > 4) {

        const relevance = (conLevel - 4) + (agrLevel - 4);


        combinationList.push(<Combination logo1={C} logo2={A2} title1={conName} title2={agrName} relevance={relevance}
            comboTitle={combinationsText.conAgrTitle} comboText={combinationsText.conAgrText} key={combinationsText.conAgrTitle} />);

    }

    if (conLevel > 4 && agrLevel < 4) {

        const relevance = (conLevel - 4) + (4 - agrLevel);

        combinationList.push(<Combination logo1={C} logo2={A2} title1={conName} title2={disName} relevance={relevance}
            comboTitle={combinationsText.conDisTitle} comboText={combinationsText.conDisText} key={combinationsText.conDisTitle} />);

    }

    if (conLevel > 4 && staLevel > 4) {

        const relevance = (conLevel - 4) + (staLevel - 4);

        combinationList.push(<Combination logo1={C} logo2={S} title1={conName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.conStaTitle} comboText={combinationsText.conStaText} key={combinationsText.conStaTitle} />);

    }

    if (conLevel > 4 && staLevel < 4) {

        const relevance = (conLevel - 4) + (4 - staLevel);

        combinationList.push(<Combination logo1={C} logo2={S2} title1={conName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.conNeuTitle} comboText={combinationsText.conNeuText} key={combinationsText.conNeuTitle} />);

    }

    //unconcientious

    if (conLevel < 4 && extLevel > 4) {

        const relevance = (4 - conLevel) + (extLevel - 4);

        combinationList.push(<Combination logo1={C2} logo2={E} title1={uncName} title2={extName} relevance={relevance}
            comboTitle={combinationsText.uncExtTitle} comboText={combinationsText.uncExtText} key={combinationsText.uncExtTitle} />);

    }

    if (conLevel < 4 && extLevel < 4) {

        const relevance = (4 - conLevel) + (4 - extLevel);

        combinationList.push(<Combination logo1={C2} logo2={E2} title1={uncName} title2={intName} relevance={relevance}
            comboTitle={combinationsText.uncIntTitle} comboText={combinationsText.uncIntText} key={combinationsText.uncIntTitle} />);

    }

    if (conLevel < 4 && agrLevel > 4) {

        const relevance = (4 - conLevel) + (agrLevel - 4);

        combinationList.push(<Combination logo1={C2} logo2={A2} title1={uncName} title2={agrName} relevance={relevance}
            comboTitle={combinationsText.uncAgrTitle} comboText={combinationsText.uncAgrText} key={combinationsText.uncAgrTitle} />);

    }

    if (conLevel < 4 && agrLevel < 4) {

        const relevance = (4 - conLevel) + (4 - agrLevel);

        combinationList.push(<Combination logo1={C2} logo2={A2} title1={uncName} title2={disName} relevance={relevance}
            comboTitle={combinationsText.uncDisTitle} comboText={combinationsText.uncDisText} key={combinationsText.uncDisTitle} />);

    }

    if (conLevel < 4 && staLevel > 4) {

        const relevance = (4 - conLevel) + (staLevel - 4);

        combinationList.push(<Combination logo1={C2} logo2={S} title1={uncName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.uncStaTitle} comboText={combinationsText.uncStaText} key={combinationsText.uncStaTitle} />);

    }

    if (conLevel < 4 && staLevel < 4) {

        const relevance = (4 - conLevel) + (4 - staLevel);

        combinationList.push(<Combination logo1={C2} logo2={S2} title1={uncName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.uncNeuTitle} comboText={combinationsText.uncNeuText} key={combinationsText.uncNeuTitle} />);

    }

    //extraverted

    if (extLevel > 4 && agrLevel > 4) {

        const relevance = (extLevel - 4) + (agrLevel - 4);

        combinationList.push(<Combination logo1={E} logo2={A} title1={extName} title2={agrName} relevance={relevance}
            comboTitle={combinationsText.extAgrTitle} comboText={combinationsText.extAgrText} key={combinationsText.extAgrTitle} />);

    }

    if (extLevel > 4 && agrLevel < 4) {

        const relevance = (extLevel - 4) + (4 - agrLevel);

        combinationList.push(<Combination logo1={E} logo2={A2} title1={extName} title2={disName} relevance={relevance}
            comboTitle={combinationsText.extDisTitle} comboText={combinationsText.extDisText} key={combinationsText.extDisTitle} />);

    }

    if (extLevel > 4 && staLevel > 4) {

        const relevance = (extLevel - 4) + (staLevel - 4);

        combinationList.push(<Combination logo1={E} logo2={S} title1={extName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.extStaTitle} comboText={combinationsText.extStaText} key={combinationsText.extStaTitle} />);

    }

    if (extLevel > 4 && staLevel < 4) {

        const relevance = (extLevel - 4) + (4 - staLevel);

        combinationList.push(<Combination logo1={E} logo2={S2} title1={extName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.extNeuTitle} comboText={combinationsText.extNeuText} key={combinationsText.extNeuTitle} />);

    }

    //introverted

    if (extLevel < 4 && agrLevel > 4) {

        const relevance = (4 - extLevel) + (agrLevel - 4);

        combinationList.push(<Combination logo1={E2} logo2={A} title1={intName} title2={agrName} relevance={relevance}
            comboTitle={combinationsText.intAgrTitle} comboText={combinationsText.intAgrText} key={combinationsText.intAgrTitle} />);

    }

    if (extLevel < 4 && agrLevel < 4) {

        const relevance = (4 - extLevel) + (4 - agrLevel);

        combinationList.push(<Combination logo1={E2} logo2={A2} title1={intName} title2={disName} relevance={relevance}
            comboTitle={combinationsText.intDisTitle} comboText={combinationsText.intDisText} key={combinationsText.intDisTitle} />);

    }

    if (extLevel < 4 && staLevel > 4) {

        const relevance = (4 - extLevel) + (staLevel - 4);

        combinationList.push(<Combination logo1={E2} logo2={S} title1={intName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.intStaTitle} comboText={combinationsText.intStaText} key={combinationsText.intStaTitle} />);

    }

    if (extLevel < 4 && staLevel < 4) {

        const relevance = (4 - extLevel) + (4 - staLevel);

        combinationList.push(<Combination logo1={E2} logo2={S2} title1={intName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.intNeuTitle} comboText={combinationsText.intNeuText} key={combinationsText.intNeuTitle} />);

    }


    //agreeable

    if (agrLevel > 4 && staLevel > 4) {

        const relevance = (agrLevel - 4) + (staLevel - 4);

        combinationList.push(<Combination logo1={A} logo2={S} title1={agrName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.agrStaTitle} comboText={combinationsText.agrStaText} key={combinationsText.agrStaTitle} />);

    }

    if (agrLevel > 4 && staLevel < 4) {

        const relevance = (agrLevel - 4) + (4 - staLevel);

        combinationList.push(<Combination logo1={A} logo2={S2} title1={agrName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.agrNeuTitle} comboText={combinationsText.agrNeuText} key={combinationsText.agrNeuTitle} />);

    }


    //disagreeable

    if (agrLevel < 4 && staLevel > 4) {

        const relevance = (4 - agrLevel) + (staLevel - 4);

        combinationList.push(<Combination logo1={A2} logo2={S} title1={disName} title2={staName} relevance={relevance}
            comboTitle={combinationsText.disStaTitle} comboText={combinationsText.disStaText} key={combinationsText.disStaTitle} />);

    }

    if (agrLevel < 4 && staLevel < 4) {

        const relevance = (4 - agrLevel) + (4 - staLevel);

        combinationList.push(<Combination logo1={A2} logo2={S2} title1={disName} title2={neuName} relevance={relevance}
            comboTitle={combinationsText.disNeuTitle} comboText={combinationsText.disNeuText} key={combinationsText.disNeuTitle} />);

    }


    /* Sort the items in order of relevance */

    combinationList.sort((a, b) => {

        if (a.props.relevance > b.props.relevance) {
            return -1;
        }
        else if (a.props.relevance < b.props.relevance) {
            return 1;
        }
        else {
            return 0;
        }
    }
    );

    




    const PremiumResults = ({ }) => {


        return (

            <>
                {combinationList}

            </>


        );


    }



    const NonPremiumResults = ({ setPremiumModalOpen }) => {


        return (

            <>
                {combinationList[0]}


                {(combinationList.length > 2) ? combinationList[combinationList.length / 2] : <></>}

                < PremiumLockbox setPremiumModalOpen={setPremiumModalOpen}  modalText="Purchase the full test to unlock all facet combinations"/>


            </>

        );


    }





    return (

        <>
            {isPaid ? < PremiumResults /> : < NonPremiumResults setPremiumModalOpen={setPremiumModalOpen} />}
        </>
    );



}

export default CombinationsTab;